import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import { splitTask } from "../../../redux/ducks/task";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import SelectInput from "../../dumb/SelectInput";
import NumInput from "../../dumb/NumInput";
import DisplayError from "../../dumb/DisplayError";

const SplitTask = props => {
    const [show, hide, renderModal] = useModal();
    const [d_splitTask, status, error, event] = useStatusThunk(splitTask);

    const [splitBy, setSplitBy] = useState();
    const [splitMethod, setSplitMethod] = useState();
    const [splitAmount, setSplitAmount] = useState();

    const split = (splitBy, splitMethod, splitAmount) => {
        if (props.selectedTasks.length == 1) {
            d_splitTask({ taskID: props.selectedTasks[0], splitBy, splitMethod, splitAmount });
        }
    }

    const onSubmit = e => {
        split(splitBy, splitMethod, splitAmount);
        e.preventDefault();
    }

    event.onSuccess = () => {
        hide();
        setSplitBy(null);
        setSplitMethod(null);
        setSplitAmount(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--alert " + props.className} onClick={show}>Split</button>
            {renderModal(
                <form className="split-task" onSubmit={onSubmit}>
                    <div className="group">
                        <div className="label">Split By</div>

                        <SelectInput set={setSplitBy} v={splitBy}>
                            <option value="rows">Rows</option>
                            <option value="words">Words</option>
                        </SelectInput>
                    </div>

                    <div className="group">
                        <div className="label">Split Method</div>
                        <SelectInput set={setSplitMethod} v={splitMethod}>
                            <option value="every">Every</option>
                            <option value="evenly">Evenly</option>
                        </SelectInput>
                    </div>

                    <div className="group">
                        <div className="label">Split Amount</div>
                        <NumInput set={setSplitAmount} v={splitAmount} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className={"button--alert split-task__split-button"} type="submit">Split</LoadingButton>
                </form>
            )}
        </React.Fragment>
    )
}

export default SplitTask;